import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
import { modalStyle } from "../../../../../components/modalStyle";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";

export default function ActivateModal({
  openModal,
  setOpenModal,
  row,
  onActivate,
}) {
  const handleClose = () => setOpenModal(false);

  const handleActivate = async () => {
    onActivate(row);
    handleClose();
  };

  return (
    <Modal open={openModal} onClose={handleClose}>
      <Box sx={{ ...modalStyle, width: 600 }}>
        <Box sx={{ mb: 2, textAlign: "center" }}>
          <VerifiedUserOutlinedIcon sx={{ color: "green", fontSize: 140 }} />
        </Box>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Are you sure you want to Activate ({row?.name})?
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          By Activate this user, you will enable their access to the system and
          all associated data. This action cannot be undone.
        </Typography>

        <Box sx={{ float: "right", mt: 3, gap: 2, display: "flex" }}>
          <Button variant="outlined" color="success" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleActivate}>
            Activate
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
